// Generado por scripts/gen-version.mjs. No editar ni versionar.
export const APP_VERSION = {
  "version": "1.24.1",
  "build": "af3ffb79",
  "env": "production",
  "builtAt": "2026-11-04T02:12:54.595Z"
} as { version: string; build: string; env: string; builtAt: string };
